import thumbAria from './thumb-aria.webp';
import thumbCohere from './thumb-cohere.webp';
import thumbInference from './thumb-inference.webp';
import thumbModels from './thumb-models.webp';
import thumbNeura from './thumb-neura.webp';
import thumbPinterest from './thumb-pinterest.webp';

export type Story = {
  href: string;
  thumbnail: string;
  title: string;
};

export const tutorials: Story[] = [
  {
    title: 'Accelerate the self-improving AI loop with CoreWeave ARIA',
    href: 'https://www.youtube.com/watch?v=6nD2f1qAW8Q',
    thumbnail: thumbAria,
  },
  {
    title: 'W&B Models end-to-end demo',
    href: 'https://www.youtube.com/watch?v=FkTwcxnSPes&t=91s',
    thumbnail: thumbModels,
  },
  {
    title: 'Get started with CoreWeave Dedicated Inference',
    href: 'https://youtu.be/_lfb0aGIKHQ',
    thumbnail: thumbInference,
  },
];

export const customerStories: Story[] = [
  {
    title:
      'The daily loop: How NEURA Robotics iterates on industry-leading physical AI',
    href: 'https://wandb.ai/site/customers/neura/',
    thumbnail: thumbNeura,
  },
  {
    title:
      "Fueling ML innovation at scale: Inside Pinterest's machine learning platform",
    href: 'https://wandb.ai/site/customers/pinterest/',
    thumbnail: thumbPinterest,
  },
  {
    title: 'How Cohere trains business-critical LLMs with the help of W&B',
    href: 'https://wandb.ai/site/customers/how-cohere-trains-business-critical-llms-with-the-help-of-wb/',
    thumbnail: thumbCohere,
  },
];
